var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.173,368.792a149.777,149.777,0,0,0,88.854,100.533,260.007,260.007,0,0,0,193.946,0,149.163,149.163,0,0,0,44.386-249.366l-81.59-73.431a106.426,106.426,0,0,0,52.072-22.257L381,113.744a8,8,0,0,0-10-12.494l-13.156,10.525A90.364,90.364,0,0,1,311.8,130.9a158.945,158.945,0,0,0,23.2-83V45.712a8,8,0,0,0-11.578-7.155l-35.7,17.85L261.16,29.84a8,8,0,0,0-11.313,0L223.279,56.407l-35.7-17.85A8,8,0,0,0,176,45.712v.45a161.075,161.075,0,0,0,29.269,92.23l-90.628,81.566A148.6,148.6,0,0,0,70.173,368.792ZM221.281,73.3a8,8,0,0,0,9.235-1.5L255.5,46.811,280.491,71.8a8,8,0,0,0,9.234,1.5L318.6,58.861A143.053,143.053,0,0,1,292.256,131.5H220.009A145.078,145.078,0,0,1,192.58,58.946ZM125.344,231.851,219.07,147.5h73.86l93.726,84.354A133.164,133.164,0,0,1,347.03,454.47a244.082,244.082,0,0,1-182.06,0,133.163,133.163,0,0,1-39.626-222.618Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.012,373.313l84.748,52.968a8,8,0,0,0,8.48,0l84.749-52.968a82.2,82.2,0,0,0,36.853-85.4,67.087,67.087,0,0,0-120.374-25.836L256,269.733l-5.468-7.654a67.087,67.087,0,0,0-120.374,25.835A82.2,82.2,0,0,0,167.012,373.313Zm-21.164-82.26a51.108,51.108,0,0,1,91.664-19.674l11.978,16.768a8,8,0,0,0,13.02,0l11.978-16.769a51.086,51.086,0,0,1,91.664,19.675,66.119,66.119,0,0,1-29.643,68.692L256,410.063l-80.508-50.318A66.118,66.118,0,0,1,145.848,291.053Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.657,353.155a8,8,0,0,0-11.314-11.314,14.644,14.644,0,0,1-20.686,0l-11.314,11.314a30.665,30.665,0,0,0,43.314,0Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 315.498,
    r: 13,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 315.498,
    r: 13,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.335,429.182c-2.477-.848-4.948-1.812-7.347-2.866a8,8,0,1,0-6.438,14.647c2.809,1.235,5.7,2.364,8.6,3.357a8,8,0,0,0,5.181-15.138Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.956,426.8a8,8,0,1,0,9.9-12.57,92.894,92.894,0,0,1-30.989-44.455,8,8,0,0,0-15.219,4.94A108.843,108.843,0,0,0,143.956,426.8Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/bank_logo.31122d1f8553eccfeca84074b17c7e02.svg";
export { ForwardRef as ReactComponent };